module.exports = __webpack_public_path__ + "img/IMG_0688.ff689463.jpg";